import { PLATFORMS } from '@/data/siteData'
import styles from './Modal.module.css'

export default function Modal({ type, onClose }) {
  const platform = PLATFORMS.find(p => p.id === type)
  if (!platform) return null

  const domain = platform.url.replace(/^https?:\/\//, '')

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={`${platform.name} details`}
    >
      <div
        className={styles.panel}
        style={{ borderColor: platform.modalBorder }}
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className={styles.header}>
          <span
            className={styles.status}
            style={{
              background: platform.modalStatusBg,
              border: `1px solid ${platform.modalStatusBorder}`,
              color: platform.modalStatusColor,
            }}
          >
            <span className={styles.statusDot} style={{ background: platform.modalStatusDot }} />
            {platform.modalStatus}
          </span>
          <button
            onClick={onClose}
            className={styles.closeBtn}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {/* Title */}
        <h2 className={styles.title}>{platform.modalTitle}</h2>

        {/* Description */}
        <p className={styles.desc}>{platform.modalDesc}</p>

        {/* Welcome bonus */}
        <div
          className={styles.giftBox}
          style={{
            background: platform.modalGiftBg,
            border: `1px solid ${platform.modalGiftBorder}`,
          }}
        >
          <span className={styles.giftIcon}>🎁</span>
          <div>
            <p className={styles.giftTitle}>Welcome Bonus</p>
            <p className={styles.giftDesc}>
              Sign up and receive <strong style={{ color: platform.modalGiftColor }}>1,000 GNC</strong> — equal to <strong style={{ color: platform.modalGiftColor }}>₹1,000 INR</strong>. Spend them on any purchase across the entire NexusAI ecosystem.
            </p>
          </div>
        </div>

        {/* CTA */}
        <a
          href={platform.url}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.ctaBtn}
          style={{
            background: platform.modalBtnGrad,
            boxShadow: `0 4px 24px ${platform.modalBtnShadow}`,
          }}
        >
          Visit {platform.name} →
        </a>
        <p className={styles.ctaNote}>{domain}</p>
      </div>
    </div>
  )
}
